import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin: -2px 0 0 5px;
  cursor: pointer;
`
